export default __webpack_public_path__ + "static/media/logo-spinner.842321d0.gif";